<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <p>Современный мир очень сложен для познания, но цифровые технологии дают нашим детям такие возможности, которые нам самим даже и не снились. Чтобы
          с толком использовать достижения научной мысли для развития ребёнка, подключайтесь к занятиям на образовательной платформе HomeTeacher вместе с Полиглотиками!
        </p>

        <h2 class="redh2">О платформе HomeTeacher</h2>

        <p>HomeTeacher &ndash; это платформа, на которой представлены онлайн-уроки немецкого для детей 4, 5, 6 лет. Для того, чтобы начать занятия, достаточно ввести в специальной форме на сайте возраст ребёнка и интересующий вас иностранный язык. Выбрав нужный курс и внеся оплату, вы получите доступ к видеоурокам и методическим материалам. Доступ сохраняется на срок от года до 18 месяцев, поэтому вы можете учиться не спеша, самостоятельно определяя периодичность занятий.</p>

        <h2 class="greenh2">Преимущества  видеокурсов от HomeTeacher</h2>

        <ol>
          <li><span>Эффективное преподавание.  Онлайн-обучение дошкольников немецкому языку проводят исключительно опытные сертифицированные преподаватели, в том числе и носители языка. Мы серьёзно относимся к подбору кадров &ndash; лишь 1 преподаватель из 50 становится нашим сотрудником.</span></li>
          <li><span>Низкие цены. Мы сделали дистанционное обучение дошкольников немецкому языку доступным для всех желающих. Стоимость одного занятия на платформе начинается от 90 рублей, а целого курса — от 290 рублей. Вам не потребуется сложное дорогостоящее оборудование &ndash; достаточно обычного телефона или планшета.</span></li>
          <li><span>Нестандартный поход к занятиям. Онлайн курсы немецкого языка для дошкольников разработаны с учётом новейших открытий в области возрастной психологии. Мы избавим вашего ребёнка от нудной зубрёжки! Занятия для детей 4-6, а также 7 и 8 лет основаны на коммуникативном подходе. С первого урока ребёнок погружается в атмосферу игры и без усилий усваивает новые слова.</span></li>
        </ol>

        <h2 class="redh2">Результаты занятий на платформе</h2>

        <p>Исследования показывают, что дистанционное изучение иностранного по уровню эффективности практически не уступает обычным занятиям в классе.</p>

        <h2 class="greenh2">Онлайн-школа для дошкольников по немецкому языку научит детей:</h2>

        <ul>
          <li><span>Понимать иностранную речь и без стеснения поддерживать простой диалог с преподавателем. За время обучения словарный запас ребёнка существенно расширится, что откроет новые возможности для общения.</span></li>
          <li><span>Концентрировать внимание на заданиях педагога и творчески подходить к их выполнению. Смена разнообразных занятий в ходе урока помогает эффективно развивать память и мышление ребёнка.</span></li>
          <li><span>Систематически заниматься и самостоятельно выполнять домашние задания.   В ходе занятий у детей дошкольного и младшего школьного возраста формируется устойчивый интерес к обучению.</span></li>
        </ul>

        <p>После окончания курса ребёнок получит красочный подарочный сертификат, который наверняка станет предметом его гордости.</p>

        <p>Начинать учить иностранный язык можно в любом возрасте! Методисты сети «Полиглотики» разработали более 70 оригинальных учебных программ для школьников и детей дошкольного возраста. Зарегистрируйтесь на сайте, выберите подходящий курс и приступайте к занятиям в любое удобное время. Для вашего удобства первый урок можно пройти совершенно бесплатно!</p>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang3Age2"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
